import React from "react";
import {Box, Link, Toolbar} from "@mui/material";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import BirdIcon from "../../assets/icon/legalbird.svg";
import { navigationBarBrandStyles } from "./navigationBarBrandStyles";


const NavigationBarBrand = () => {
  return (
    <>
      <AppBar position={"sticky"} color={"inherit"}>
        <Toolbar>
          <Grid
            container
            sx={{
              alignItems: "center",
              justifyContent: "center"
            }}>
            <Grid sx={navigationBarBrandStyles.iconContainer} size={12}>
              <Link href={"/"}>
                <Box component={"img"} sx={navigationBarBrandStyles.navBarIcon} src={BirdIcon} alt={"Legalbird"} />
              </Link>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default NavigationBarBrand;
